import React from 'react';
import { Show, List, TabbedShowLayout, Tab, ImageField, TextField, BooleanField, TopToolbar, RefreshButton, ListButton, EditButton, ReferenceManyField, DateField, Datagrid, ReferenceField, GET_ONE, usePermissions, useRecordContext, useResourceContext, useGetOne } from 'react-admin';
import { CamelCaseField, ExpectedDateField } from '../digitalOrders/common';
import { getLocalStorageKey } from '../common/common';
import Modal from 'react-responsive-modal';
import FormattedCurrencyNumberCustom from '../formatted-currency-number-custom';
import Spinner from '../../src/spinner';
import { CommonHeaderOption } from '../common/common';
import myDataProvider from '../myRestProvider';
import { useLocation } from "react-router-dom";
// const cardActionStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };

class ExampleApp extends React.Component {
  constructor(props) {
    super(props);
    this.fetchItem(props.id);
    this.reload = this.reload.bind(this);
    this.state = {
      open: false,
      showloader: true,
      reloadButton: false,
      data: {},
      dateFlag: false,
      showModalForZambiaTanzania: false,
      showModalForOtherCountries: false,
    };
    console.log('permission123', props)
    console.log('id is', props.id)
  }

  componentDidMount() {
    const { props } = this;
    if (props.permissions === 'isJDE') {
      this.setState({
        showModalForZambiaTanzania: true,
      });
    } else {
      this.setState({
        showModalForOtherCountries: true,
      });
    }
  }

  onOpenModal = () => {
    console.log(this.props);
    this.setState({ open: true, reloadButton: false });
    this.fetchItem(this.props.id);
    // if (this.state.showModalForOtherCountries) {
    // } else {
    //     this.fetchItemForJDE(this.props.record._links.self.href);
    // }
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };
  render() {
    const { open } = this.state;
    return (
      <div className="detailsBtn">
        {
          !open ?
            <p onClick={this.onOpenModal}>Check balance</p>
            :
            <Modal open={open} onClose={this.onCloseModal} center>
              <table>
                {this.state.showModalForZambiaTanzania &&
                  <div>
                    <tr>
                      <th>Payment term</th>
                      <th>OutStanding Payments</th>
                      <th>Credit Limit</th>
                      <th>Paid-In Amount</th>
                      <th>Credited Amounts</th>
                      <th>Invoiced Amounts</th>
                      <th>Open Orders Amount</th>
                      <th>Amount owed between 1-30 days</th>
                      <th>Over 30 days</th>
                      <th>Available Balance</th>
                    </tr>
                    <tr>
                      <td>{this.state.data.payment_terms ? this.state.data.payment_terms : ''}</td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.outstanding_payments ? this.state.data.outstanding_payments : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.credit_limit ? this.state.data.credit_limit : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.paid_in_amount ? this.state.data.paid_in_amount : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.credited_amounts ? this.state.data.credited_amounts : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.invoiced_amount_not_yet_paid ? this.state.data.invoiced_amount_not_yet_paid : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.orders_not_invoiced_price ? this.state.data.orders_not_invoiced_price : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.current_and_1_to_30_days ? this.state.data.current_and_1_to_30_days : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.over_30_days ? this.state.data.over_30_days : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.sap_digital_order_balance ? this.state.data.sap_digital_order_balance : 0
                          }
                        />
                      </td>
                    </tr>
                  </div>
                }
                {this.state.showModalForOtherCountries &&
                  <div>
                    <tr>
                      <th>SAP credit area Cd</th>
                      <th>Last SAP update</th>
                      <th>Currency</th>
                      <th>Credit limit</th>
                      <th>Credit exposure SAP</th>
                      <th>Credit exposure LOGON</th>
                      <th>Open credit LOGON</th>
                      <th>Orders not invoiced price</th>
                      <th>Digital order balance</th>
                    </tr>
                    <tr>
                      <td>{this.state.data.sap_credit_area_cd ? this.state.data.sap_credit_area_cd : ''}</td>
                      <td >{this.state.dateFlag && this.state.data.last_sap_update}</td>
                      <td>{this.state.data.currency ? this.state.data.currency : ''}</td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.credit_limit ? this.state.data.credit_limit : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.credit_exposure_sap ? this.state.data.credit_exposure_sap : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.credit_exposure_logon ? this.state.data.credit_exposure_logon : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.open_credit_logon ? this.state.data.open_credit_logon : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.orders_not_invoiced_price ? this.state.data.orders_not_invoiced_price : 0
                          }
                        />
                      </td>
                      <td>
                        <FormattedCurrencyNumberCustom
                          value={
                            this.state.data.sap_digital_order_balance ? this.state.data.sap_digital_order_balance : 0
                          }
                        />
                      </td>
                    </tr>
                  </div>
                }
                <tr className='errorMsg'>
                  <td colspan="9">{this.state.reloadButton &&
                    <div>{this.state.data.msgText}</div>
                  }</td>
                </tr>
                <tr>
                  <td className='spinner' colspan="9"><div className="spinner">
                    {this.state.showloader && window.navigator.onLine &&
                      <Spinner />
                    }
                  </div>
                    {this.state.reloadButton &&
                      <div className="refresh" >
                        <i onClick={this.reload} class="material-icons">
                          refresh
                        </i>
                      </div>
                    }
                    <div>
                      {!window.navigator.onLine &&
                        <p>It seems that you are offline. Please check your internet connection</p>
                      }
                    </div>
                  </td>
                </tr>
              </table>
            </Modal>
        }
      </div >
    );
  }
  reload() {
    this.setState({
      reloadButton: false,
      showloader: true
    }, () => this.fetchItem(this.props.id));
  }

  fetchItem = async (id) => {
    this.setState({ showloader: true, data: {} },
      async () => {
        const json = await myDataProvider(GET_ONE, 'getSapDetails', { id });
        console.log('json', json);
        const item = json.data;
        var countryTime = new Date(item && item.last_sap_update).toLocaleString("en-US");
        console.log('countryTime', countryTime);
        this.setState({
          showloader: false,
          data: {
            ...item,
            last_sap_update: countryTime,
          },
          reloadButton: item && item.errorMsg === 'Reload',
          dateFlag: countryTime !== 'Invalid Date',
        });
      });
  }

  // fetchItemForJDE = async (apiUrl) => {
  //     const url = `${apiUrl}/fetch_balance`;
  //     const options = CommonHeaderOption()
  //     options.method = 'GET';
  //     return fetch(url, options)
  //         .then(res => {
  //             if (res.status === 401) {
  //             localStorage.removeItem("__state");
  //             window.location.href = "#/login";
  //             }
  //             return res.json();
  //         })
  //         .then(json => {
  //             this.setState({ showloader: true, data: {} },
  //                 async () => {
  //                     const item = json.data;
  //                     var countryTime = new Date(item && item.last_sap_update).toLocaleString("en-US");
  //                     console.log('countryTime', countryTime);
  //                     this.setState({
  //                         showloader: false,
  //                         data: {
  //                             ...item,
  //                             last_sap_update: countryTime,
  //                         },
  //                         reloadButton: item && item.errorMsg === 'Reload',
  //                         dateFlag: countryTime !== 'Invalid Date',
  //                     });
  //                 });
  //             });
  // }
}
const ShowActions = ({ permissions }) => {
  const resource = useResourceContext();
  const record = useRecordContext();
  localStorage.setItem("businessID", record?.id);
  const { data } = useGetOne("businesses", { id: record?.id });
  return (
    <TopToolbar>
      <RefreshButton />
      <ListButton resource={resource} />
      {(permissions === 'isManual' || permissions === 'isJDE' || permissions === 'isSageAPI') &&
        <EditButton resource={resource} record={data} />
      }
    </TopToolbar>
  )
}

const ShowTitle = () => {
  const record = useRecordContext();
  return <span>Sold To - {record ? `${record.name} ` : ''}</span>;
};

const BusinessesShow = () => {
  const {permissions} = usePermissions();
  const record = useRecordContext();
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  const showAllOrders = getLocalStorageKey('show_all_orders');

  return (
    <Show actions={<ShowActions permissions={permissions.permissions} />} title={<ShowTitle />}>

      <TabbedShowLayout className="tab-scroll">

        <Tab label="Profile Details" contentClassName="scrollTab" className="">
          {/* <ImageField source="profile_data_url" title="Profile Image" label="Profile" /> */}
          <TextField source="phone" />
          <TextField source="name" />
          <TextField label="Sold To ID" source="sap_code" />
          <TextField source="email" />
          <TextField source="address" />
          {/* {(permissions === 'isSap' || permissions === 'isJDE') &&
            <ExampleApp id={businessIdVal} permissions={permissions} />
          } */}
          <TextField source="total_credit_cents" label="My Store credit" />
          <TextField source="contact_person" />
          <TextField source="sap_digital_order_balance" />
          <TextField source="orders_not_invoiced_price" />
          <BooleanField source="is_sap_blocked" />
          <BooleanField source="is_sap_deleted" />
          <BooleanField source="is_ordering_blocked" />

        </Tab>


        <Tab label="Contracts">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference="sap_contracts"
            source="id"
            target="business_id"
            className="tab-pagination"
          >
            <List actions={false} sort={{ field: 'created_at', order: 'DESC' }} filterDefaultValues={{ business_id: businessIdVal }} exporter={false}>
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <TextField source="contract_number" />
                <TextField source="contract_type" />
                <TextField source="retailer_info.sap_code" label="Sold To ID" sortable={false} />
                <DateField label="Contract Valid From" source="contract_valid_from" />
                <DateField label="Contract Valid To" source="contract_valid_to" />
                <TextField source="inco_term" />
                <DateField label="Created at" source="created_at" sortable={false} />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label="Orders">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'creation_date', order: 'DESC' }}
            reference={showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"}
            source="id"
            target="business_id"
            className="tab-pagination"
          >
            <List actions={false} filterDefaultValues={{ business_id: businessIdVal }} exporter={false} sort={{ field: 'creation_date', order: 'DESC' }} >
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <DateField label={'Order Date'} source="creation_date" showTime />
                <TextField source="order_number" />
                <CamelCaseField source="mode_of_delivery" label="Mode Of Delivery" />
                <ExpectedDateField label="Expected Date" source="delivery_date_from" />
                <TextField label="Local PO / Note" source="customer_ref_number" />
                <TextField label="Order Status" source="customer_order_status_desc" />
                <ReferenceField label="Ship To Name" source="sap_business_site_id" reference="sap_business_sites" link="show" allowEmpty>
                  <TextField source="name" />
                </ReferenceField>
                {
                  permissions.permissions === 'isSap' &&
                  <DateField label="Date 1st seen in LR" source="created_at" />
                }
                {
                  permissions.permissions === 'isSap' && showAllOrders &&
                  <TextField label="Is App Order" source="is_app_order" />
                }
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label="Ship Tos">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference="sap_business_sites"
            source="id"
            target="business_id"
            className="tab-pagination"
          >
            <List actions={false} filterDefaultValues={{ business_id: businessIdVal }} sort={{ field: 'created_at', order: 'DESC' }} exporter={false}>
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <TextField label="Ship To ID" source="ship_to_sap_number" />
                <TextField label="Ship To Name" source="name" allowEmpty />
                <TextField source="phone" sortable={false} allowEmpty />
                <TextField label="Sold To Code" source="retailer_sapcode" sortable={false} />
                <DateField label="Created at" source="created_at" allowEmpty />
                <TextField source="status" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );

};

export default BusinessesShow;